import { forceUpdate, h } from "@stencil/core";
import { i18nProvider } from "@trumpf/ux.i18n";
import loadTranslations from "../../utils/loadTranslations";
import { utcFromTime } from "../../utils/utcFromTime";
import { createPhoneLink } from "../../utils/createPhoneLink";
export class CreateServiceCaseSuccess {
    constructor() {
        /** Response from the API */
        this.response = null;
        /** Locale for the component */
        this.locale = null;
        /** BaseUrl for MyTrumpf */
        this.myTrumpfBaseUrl = "";
        /** used inside a modal */
        this.isInModal = false;
    }
    connectedCallback() {
        var _a;
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
        this.onLocaleChange();
        this.isInModal = ((_a = this.el) === null || _a === void 0 ? void 0 : _a.closest("ux-modal")) !== null;
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }
    onLocaleChange() {
        if (this.locale !== i18nProvider.language) {
            this.loadTranslations();
        }
    }
    loadTranslations() {
        loadTranslations(this.locale).then((locale) => {
            i18nProvider.changeLanguage(locale);
            this.locale = locale;
        });
    }
    render() {
        var _a, _b, _c;
        const t = (key, options = undefined) => i18nProvider.t(`mf-service-calls:${String(key)}`, options);
        const time = (time) => time && h("ux-date-time", { key: 'a5c6b130cb8a3a10da9f811fcb03971c1ab1d5cd', utc: utcFromTime(time), format: t("timeFormat") });
        const { isOutsideOfServiceHours, technicalServiceHotline, technicalGuideAvailable, isCustomerOrderNumberRequired, sisCaseId, serviceHours } = ((_a = this.response) === null || _a === void 0 ? void 0 : _a[0]) || {};
        const hasMonFri = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd));
        const hasSat = Boolean((serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart) && (serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd));
        const monFriHtml = hasMonFri && (h("div", { key: 'f21e9d34767cf5f91b187612f001acb920b18fb8' }, t("sisConnector.success.serviceTimes.MonFri"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.MonFriEnd)));
        const satHtml = hasSat && (h("div", { key: '67b58c0849182644956c02a574bb50309de270bb' }, t("sisConnector.success.serviceTimes.Sat"), " ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatStart), " - ", time(serviceHours === null || serviceHours === void 0 ? void 0 : serviceHours.SatEnd)));
        const activeTabOnDetailPage = ((_c = (_b = this.response) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.technicalGuideAvailable)
            ? "activeTabId=sisServiceCallsTabSisProductReports"
            : "activeTabId=serviceCaseTabAiAssistant";
        return (h("div", { key: '50661b728c1f9701295d8691040ea62892ae9498', class: "ux-u-text-align--center" }, h("div", { key: '7ea360f23ef837d94dea3b0fee9b74bb68cea663', class: "ux-u-mb-xxs" }, h("ux-icon", { key: 'c989670b0d8fd20dcea45ec9117d023660a3552a', style: { fontSize: "100px" }, class: "ux-color-success ux-icon", name: "checkmark" })), h("div", { key: '49f7b47e4659c1197186f87e2515a15cac3e0cd9', class: "ux-text-headline ux-text-headline--big ux-u-mb-xxs" }, t("sisConnector.success.headline")), isOutsideOfServiceHours && (h("div", { key: '345679b47d39be46f1541c28464a4eae0389b35f', class: "ux-text-normal" }, h("p", { key: 'ca07af9277d24e885688b07234321525aa07a194' }, t("sisConnector.success.outsideOfServiceHours")), h("strong", { key: 'fc588f5b44ff3a6a7d53919c88357c19e7100ef9' }, monFriHtml, satHtml))), technicalServiceHotline && (h("p", { key: '14ff2b518e00a0033b2e35b19cc536ed707d7387', class: "ux-text-normal", innerHTML: t("sisConnector.success.withTechnicalServiceHotline", {
                hotline: createPhoneLink(technicalServiceHotline, "mf-create-service-case-success__link"),
                interpolation: { escapeValue: false }
            }) })), !technicalServiceHotline && (h("p", { key: 'da812158e6d24a0135499f9eb98343787fef90b0', class: "ux-text-normal" }, t("sisConnector.success.withoutTechnicalServiceHotline"))), technicalGuideAvailable && (h("div", { key: 'a11f4a43393f7948bf2653692122e0b064a34dd8' }, h("div", { key: '4cc2c17b2c4156710cb9bbb8f3e67393550f60c8', class: "ux-text-headline--big" }, t("sisConnector.success.technicalGuide.title")), h("p", { key: 'a2d026ba373e7c99f431af309afeb8680d0e804f', class: "ux-text-normal" }, t("sisConnector.success.technicalGuide.text")))), isCustomerOrderNumberRequired && (h("div", { key: '2039a8a52435b427346ce42f667656364a5c75e4' }, h("div", { key: '8971b2dc857fe304f51d662fcc2b51be3ba6b970', class: "ux-text-headline--big" }, t("sisConnector.success.orderNumberRequired.title")), h("p", { key: 'ae5110dea313c05b14716ca60a26b96a5ef42346', class: "ux-text-normal" }, t("sisConnector.success.orderNumberRequired.text")))), h("div", { key: '5c212015aee8565c004733021182cf6289f66c50', class: "ux-text-normal" }, h("p", { key: 'fae6836e0b9e23744b200244fe38d6302fc59f60' }, h("a", { key: 'b358509849adf19a8ab61415fbd75b0e821c4284', class: "mf-create-service-case-success__link", href: `${this.myTrumpfBaseUrl}/go/mytrumpf/my-service-cases/case/${sisCaseId}/?${activeTabOnDetailPage}` }, t("sisConnector.success.caseId"), ": ", sisCaseId))), !this.isInModal && (h("ux-button", { key: '0e33c66dbe3bfe7fab74953f728275f7576b07db', class: "ux-u-margin-top-20", type: "button", variant: "primary", onClick: () => { var _a; return (_a = this.clickHandler) === null || _a === void 0 ? void 0 : _a.call(this); }, formnovalidate: true }, t("button.ok")))));
    }
    static get is() { return "mf-create-service-case-success"; }
    static get originalStyleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["create-service-case-success.css"]
        };
    }
    static get properties() {
        return {
            "response": {
                "type": "unknown",
                "attribute": "response",
                "mutable": false,
                "complexType": {
                    "original": "CreateCaseResponse | null",
                    "resolved": "CreateCaseResponseItem[] | null",
                    "references": {
                        "CreateCaseResponse": {
                            "location": "import",
                            "path": "../../api/publicApi/createCase/createCase",
                            "id": "src/api/publicApi/createCase/createCase.ts::CreateCaseResponse"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Response from the API"
                },
                "getter": false,
                "setter": false,
                "defaultValue": "null"
            },
            "clickHandler": {
                "type": "unknown",
                "attribute": "click-handler",
                "mutable": false,
                "complexType": {
                    "original": "() => void",
                    "resolved": "() => void",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Click handler for the success button"
                },
                "getter": false,
                "setter": false
            },
            "locale": {
                "type": "string",
                "attribute": "locale",
                "mutable": false,
                "complexType": {
                    "original": "string | null",
                    "resolved": "null | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Locale for the component"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "null"
            },
            "myTrumpfBaseUrl": {
                "type": "string",
                "attribute": "my-trumpf-base-url",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "BaseUrl for MyTrumpf"
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "\"\""
            }
        };
    }
    static get states() {
        return {
            "isInModal": {}
        };
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "locale",
                "methodName": "onLocaleChange"
            }];
    }
}
//# sourceMappingURL=create-service-case-success.js.map
